import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column, Button } from '@resurs/midas-react'
import { Conditional } from '@resurs/react-utils'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import PaymentDoneContent from './PaymentDoneContent'
import InvoiceDoneContent from './InvoiceDoneContent'
import { PaymentMethods } from '../../../../models/payment-methods'
import { fetchInvoicePdf as fetchInvoicePdfAction } from '../../../../store/actions/transactions-actions'
import successAnimation from '../../../../assets/animations/success_animated.svg'
import { getText } from '../../../../internal/TextLabels'
import PageWrapper from '../../../../internal/PageWrapper'
import PrintModalUI from '../shared/PrintModalUI'

class PaymentDonePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { pdfUrl: null }
  }

  getDocumentInfo() {
    const paymentResult = this.props.data.payment.paymentResult
    if (
      paymentResult &&
      paymentResult.payment &&
      paymentResult.payment.paymentLog
    ) {
      const firstPayment = paymentResult.payment.paymentLog.find(
        payment => payment.invoiceData && payment.invoiceData.pdfId,
      )
      if (firstPayment && firstPayment.invoiceData) {
        return {
          pdfId: firstPayment.invoiceData.pdfId,
          documentName: firstPayment.invoiceData.documentName,
        }
      }
    }
    return null
  }

  getInvoicePdf(document) {
    this.props
      .fetchInvoice(document.pdfId, document.documentName)
      .then(url => url && this.setState({ pdfUrl: url }))
  }

  render() {
    const document = this.getDocumentInfo()
    return (
      <>
        <Conditional when={!!this.state.pdfUrl}>
          {() => (
            <PrintModalUI
              url={this.state.pdfUrl}
              show={!!this.state.pdfUrl}
              closeText={getText('default.close')}
              onClose={() => this.setState({ pdfUrl: null })}
            />
          )}
        </Conditional>
        <PageWrapper type="success">
          <div>
            <Container>
              <Columns>
                <Column col1>
                  <img
                    style={{ margin: '1rem 1rem' }}
                    src={successAnimation}
                    alt="Success animation"
                  />
                </Column>
                <Column col11>
                  <h4 style={{ margin: '2.2rem 1rem 0 0' }}>
                    {this.props.data.payment.paymentResult.paymentMethod
                      .type !== PaymentMethods.RESURS_INVOICE
                      ? getText('payApply.paymentDone.title')
                      : getText('payApply.invoiceDone.title')}
                  </h4>
                </Column>
              </Columns>
              {this.props.data.payment.paymentResult.paymentMethod.type !==
                PaymentMethods.RESURS_INVOICE && (
                <PaymentDoneContent
                  result={this.props.data.payment.paymentResult}
                  data={this.props.data}
                />
              )}
              {this.props.data.payment.paymentResult.paymentMethod.type ===
                PaymentMethods.RESURS_INVOICE && (
                <InvoiceDoneContent
                  paymentDetails={this.props.data.payment.paymentResult}
                  fetchInvoice={() => this.getInvoicePdf(document)}
                  showPrintButton={!!(document && document.pdfId)}
                />
              )}
            </Container>
          </div>
        </PageWrapper>
        <PageWrapper>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '2rem',
            }}
          >
            <NavLink to="/apply">
              <Button>{getText('payApply.restart')}</Button>
            </NavLink>
            <Button type="primary" onClick={() => this.props.onNext()}>
              {getText('payApply.logout')}
            </Button>
          </div>
        </PageWrapper>
      </>
    )
  }
}

PaymentDonePage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  fetchInvoice: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  fetchInvoice: (pdfId, documentName) =>
    dispatch(fetchInvoicePdfAction(pdfId, documentName)),
})

export default connect(null, mapDispatchToProps)(PaymentDonePage)
